import React, {useContext, useEffect, useState, Fragment, useRef} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';
import { useReactToPrint } from 'react-to-print';
import ComprobanteEnvio from '../components/ComprobanteEnvio';

// USADO PARA LOS ROLES NOTIFICADOR, ADMIN Y SUPERVISOR

const NotificacionesNotificador = () => {
  const printComponentRef = useRef();

  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [notificaciones, setNotificaciones] = useState([]);
  const [notificacionParaImprimir, setNotificacionParaImprimir] = useState({});
  const [estadoNotificaciones, setEstadoNotificaciones] = useState('todos');
  const estados = ['creado', 'enviado', 'leido', 'todos']
  const [header, setHeader] = useState([]);
  const [query, setQuery] = useState({
    query: "",
    f_desde: null,
    f_hasta: null
  });

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if(
        authInformation.autenticado === true && (
          authInformation.rol === 'Notificador' ||
          authInformation.rol === 'Admin' ||
          authInformation.rol === 'Veedor' ||
          authInformation.rol === 'Supervisor'
        )){
      setRenderHTML(true)
      obtenerNotificaciones('', '', 1, 'estado=todos')
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  useEffect(() => {
    if(notificacionParaImprimir && notificacionParaImprimir.id){
      setNotificaciones(prevArray => {
        return prevArray.map(ntf => {
          if(ntf.id == notificacionParaImprimir.id){
            return {...ntf, estado: notificacionParaImprimir.estado};
          }

          return ntf;
        })
      })
      handlePrint()

    }
  }, [notificacionParaImprimir]);

  useEffect(() => {
    if(estadoNotificaciones!==null){
      obtenerPagina()
    }
  }, [estadoNotificaciones]);

  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  });

  const obtenerPagina = async (page=1) => {
    if(estadoNotificaciones!==null){
      obtenerNotificaciones('', query, page, 'estado=' + estadoNotificaciones)
    } else {
      obtenerNotificaciones('', query, page, '')
    }
  };

  const abrirNotificacion = (notificacion_id) => {
    navigate(`/notificacion/${notificacion_id}/edit`);
  }

  const mostrarNotificacion = (notificacion_id) => {
    navigate(`/notificacion/${notificacion_id}`);
  }

  const obtenerNotificaciones = async (sortBy='', q='', page=1, otro='') => {
    try {
        const data = await resourcesServices.obtenerResources('notificaciones', sortBy, q, page, otro);

        if (page === 1) {
          setNotificaciones(data.data);
        } else {
          setNotificaciones([...notificaciones, ...data.data]);
        }

        setHeader(data.headers);

      } catch (error) {
        errorMessage(error)
      }
  }

  const eliminarNotificacion = async (notificacion_id) => {
    try {
      if(window.confirm('Está seguro que quiere eliminar la notificacion?')) {
        await resourcesServices.eliminarResource('notificaciones', notificacion_id);

        const copiaNotificaciones = [...notificaciones];
        setNotificaciones(copiaNotificaciones.filter((notif) => notif.id !== notificacion_id))
      }
    } catch (error) {
      errorMessage(error)
    }
  }

  const cambiarEstado = async (notificacion_id) => {
    try {
      if(window.confirm('Está seguro que quiere enviar la notificacion?')) {
        const data = await resourcesServices.actualizarResource('notificaciones', notificacion_id, {notificacion: {estado: "para_enviar"}});
        setNotificacionParaImprimir(data)
      }
    } catch (error) {
      errorMessage(error)
    }
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    obtenerNotificaciones('', query, 1, '')
  }

  return (
    <div>
      <h1>Notificaciones <BotonVolver /></h1>
      {renderHTML && (
        <>
        Filtros:
          <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
            {
              estados.map((estado, index) => (
                <div key={index} className='ms-1'>
                  <input
                    type="radio"
                    className="btn-check"
                    name={`radio${index}`}
                    id={`radio${index}`}
                    value={estado}
                    autoComplete="off"
                    checked={estadoNotificaciones === estado}
                    onChange={(e) => setEstadoNotificaciones(e.target.value)}
                    />
                  <label className="btn btn-outline-primary" htmlFor={`radio${index}`}>{estado}</label>
                </div>
              ))
            }
          </div>

          <form className="row g-3 align-items-center mb-3" onSubmit={handleFormSubmit}>
            {/* <pre>{JSON.stringify(query, null, 2)}</pre> */}
            <div className="col">
              <label className="">Criterio de búsqueda</label>
              <input type="text" placeholder='Expediente o cédula o nombre del Obligado' onChange={(e) => setQuery({...query, ["query"]:e.target.value})} className="form-control" id="staticEmail2" value={query.query || ''} />
            </div>
            <div className="col">
              <label className="">Desde</label>
              <input type="date" placeholder='Fecha desde' onChange={(e) => setQuery({...query, ["f_desde"]:e.target.value})} value={query.f_desde || ''} className="form-control" />
            </div>
            <div className="col">
              <label className="">Hasta</label>
              <input type="date" placeholder='Fecha hasta' className="form-control" onChange={(e) => setQuery({...query, ["f_hasta"]:e.target.value})} value={query.f_hasta || ''} />
            </div>
            <div className="col">
              <button type="submit" className="btn btn-primary mt-3">Buscar</button>
            </div>
          </form>

          <div className="card">

          <div className="card-body px-0 pb-2">
            <div className="table-responsive">
              <table className="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Estado</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Destinatario</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Creación</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Lectura</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {notificaciones && notificaciones.map((notificacion, index) => {
                    return (
                      <Fragment key={index}>
                        <tr>
                          <td colSpan={6}>
                            <div className="d-flex px-2 py-1">
                                <div className={`p-2 flex-fill text-start mb-0 text-sm fw-bold`} >{notificacion.asunto}</div>
                                <div className='p-2 flex-fill text-end' >
                                  <b>Obligado:</b> {notificacion.usuario_notificado.value}<br />
                                  <b>Notificador:</b> {notificacion.usuario_notificador.value}<br />
                                </div>
                            </div>
                          </td>
                        </tr>
                        <tr className='border-bottom border-5 border-dark'>
                          <td>
                          <span className="badge text-bg-warning me-1">{notificacion.tipo}</span>
                          <span className="badge text-bg-secondary">{notificacion.estado === 'para_enviar' ? 'enviado' : notificacion.estado}</span>

                          </td>
                          <td className="">
                              {notificacion.usuario_notificado && `${notificacion.usuario_notificado.nombre} ${notificacion.usuario_notificado.apellido}`}
                            </td>
                          <td>
                            {notificacion.fecha_alta}
                          </td>
                          <td className='text-end'>
                            <div dangerouslySetInnerHTML={{__html: notificacion.fecha_lectura && notificacion.fecha_lectura.split(" ").join("<br />")}} />
                          </td>
                          <td>
                            <div className="btn-group" role="group" aria-label="Basic mixed styles example">
                              {
                                authInformation.rol === 'Veedor' || authInformation.rol === 'Admin' ? (
                                  <>
                                  <button type="button" onClick={()=>mostrarNotificacion(notificacion.id)} className="btn btn-primary">Mostrar</button>
                                  </>
                                ) : (
                                  <>
                                    {
                                      notificacion.estado==="creado" ? (
                                        <button type="button" onClick={()=>abrirNotificacion(notificacion.id)} className="btn btn-primary">Editar</button>
                                      ) : (
                                        <button type="button" onClick={()=>mostrarNotificacion(notificacion.id)} className="btn btn-info">Mostrar</button>
                                      )
                                    }
                                    {
                                      notificacion.estado === 'creado' && (authInformation.rol === 'Supervisor' || authInformation.es_supervisor ) && (
                                        <button type="button" disabled={notificacion.estado!=="creado"} onClick={()=>cambiarEstado(notificacion.id)} className="btn btn-warning">Enviar</button>
                                      )
                                    }
                                    {
                                      notificacion.estado==="creado" && (
                                        <button type="button" onClick={()=>eliminarNotificacion(notificacion.id)} className="btn btn-danger">Eliminar</button>
                                      )
                                    }
                                  </>
                                )
                              }

                            </div>
                          </td>
                        </tr>
                      </Fragment>
                    )
                  })
                  }
                </tbody>
              </table>

              {
                header["total-pages"] !== header["current-page"] && (
                  <div className='p-3'>
                    <button onClick={()=>obtenerPagina(header["current-page"] + 1)} className='btn btn-success mt-3'>Ver más | {header["current-page"]} de {header["total-pages"]}</button>
                  </div>
                )
              }
            </div>
          </div>
          </div>

          <ComprobanteEnvio data={notificacionParaImprimir} fechaEnvio={notificacionParaImprimir.fecha_actualizacion} refValue={printComponentRef} />
        </>
      )}
    </div>
  );
};


export default NotificacionesNotificador;